// PHASE-2.01 START
'use client';
import * as React from 'react';
export function Tooltip({ children, label }:{ children:React.ReactElement; label:string }){
  const [open,setOpen]=React.useState(false);
  return (
    <span className="relative inline-flex" onMouseEnter={()=>setOpen(true)} onMouseLeave={()=>setOpen(false)}>
      {children}
      {open && (
        <span role="tooltip" className="absolute -top-8 left-1/2 -translate-x-1/2 text-xs px-2 py-1 rounded-md bg-foreground text-background shadow">
          {label}
        </span>
      )}
    </span>
  );
}
// PHASE-2.01 END

